import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FacilityService {
  private apiUrl = '';

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.apiUrl = baseUrl;
  }

  getFacilityDtosList(pharmacyId?: number, activeOnly: boolean = true): Observable<any[]> {
    var params = new HttpParams().set('activeOnly', activeOnly ? 'true' : 'false');
    if (pharmacyId != null && pharmacyId > 0) {
      params = params.set('pharmacyId', pharmacyId.toString());
    }
    return this.http.get<any[]>(this.apiUrl + 'api/Facility/GetFacilityDtosList', { params: params });
  }
}
